module.exports = __webpack_public_path__ + "static/media/close-grey.a5463842.svg";